// extracted by mini-css-extract-plugin
export var list = "SocialLinks-module--list--1aVfG";
export var list__item = "SocialLinks-module--list__item--2Q7eP";